import React, { useState } from "react";
import PreFilter from "../../../components/BuilderComponents/PreFilters/PreFilter";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import FilterRenderer from "../../../components/BuilderComponents/FilterRenderer";
import BlockTiles from "./BlockTiles";

const ChartEditSection = ({ allTableColumns, tableId, activityId = "" }) => {
  const [selectedEditTab, setSelectedEditTab] = useState("filters");
  const { chartGlobalFilter, setChartGlobalFilter, applicationBlockData } = useAppBlocksContext();

  const settingPrefilterArray = (data) => {
    const newObj = { ...chartGlobalFilter };
    newObj.global_filters.pre_filters = data;
    setChartGlobalFilter(newObj);
  };

  const settingFilterArray = (data) => {
    const newObj = { ...chartGlobalFilter };
    newObj.global_filters.fields = data;
    setChartGlobalFilter(newObj);
  };
  const ownerPreFiltersCallBackFunction = (data) => {
    const newConfig = { ...chartGlobalFilter };
    newConfig.global_filters.owner_pre_filters = data;
    setChartGlobalFilter(newConfig);
  };

  const settingPrefiltersJoinedBy = (data) => {
    const newConfig = { ...chartGlobalFilter };
    newConfig.global_filters.prefilters_joined_by = data;
    setChartGlobalFilter(newConfig);
  };

  const settingTiles = (data) => {
    const newConfig = { ...chartGlobalFilter };
    newConfig.tiles = data;
    setChartGlobalFilter(newConfig);
  };

  return (
    <div>
      <div className="sidebar_tab_buttons">
        {["filters", "pre filters", "tiles"].map((tab) => (
          <div
            key={tab}
            className={`sidebar_tabs ${selectedEditTab === tab && "active"}`}
            onClick={() => setSelectedEditTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
      {selectedEditTab === "filters" && (
        <div className="p_3">
          <FilterRenderer
            filters={chartGlobalFilter.global_filters.fields}
            updateFilters={settingFilterArray}
            tableId={tableId}
            activityId={activityId}
            isMulti={true}
          />
        </div>
      )}
      {selectedEditTab === "pre filters" && (
        <PreFilter
          table_id={applicationBlockData.config.table_id}
          activity_id={applicationBlockData.config.activity_id || ""}
          preFilters={chartGlobalFilter.global_filters.pre_filters}
          ownerPreFilters={chartGlobalFilter.global_filters.owner_pre_filters}
          setOwnerPreFilters={ownerPreFiltersCallBackFunction}
          setPreFilters={settingPrefilterArray}
          prefiltersJoinedBy={chartGlobalFilter.global_filters.prefilters_joined_by}
          setPrefiltersJoinedBy={settingPrefiltersJoinedBy}
        />
      )}
      {selectedEditTab === "tiles" && (
        <BlockTiles
          tiles={chartGlobalFilter.tiles}
          setTiles={settingTiles}
          table_id={applicationBlockData.config.table_id}
          activity_id={applicationBlockData.config.activity_id || ""}
          allTableColumns={allTableColumns}
        />
      )}
    </div>
  );
};

export default ChartEditSection;
